var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRocket = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 18,
    viewBox: "0 0 45 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1331 1.2002C40.8461 1.2002 39.1205 2.0828 37.9613 3.6002H37.0001C36.3059 3.6002 35.9081 4.1186 35.6339 4.6664L35.2661 5.4002H37.0001L37.9001 6.3002L38.8001 7.2002V8.9336L39.5339 8.5664C40.0817 8.2928 40.6001 7.8944 40.6001 7.2002V6.239C42.1175 5.0798 43.0001 3.3536 43.0001 2.0672V1.2002H42.1331ZM40.6001 3.0002C40.7592 3.0002 40.9119 3.06341 41.0244 3.17593C41.1369 3.28845 41.2001 3.44107 41.2001 3.6002C41.2001 3.75933 41.1369 3.91194 41.0244 4.02446C40.9119 4.13698 40.7592 4.2002 40.6001 4.2002C40.441 4.2002 40.2884 4.13698 40.1758 4.02446C40.0633 3.91194 40.0001 3.75933 40.0001 3.6002C40.0001 3.44107 40.0633 3.28845 40.1758 3.17593C40.2884 3.06341 40.441 3.0002 40.6001 3.0002Z",
    fill: "url(#paint0_linear_46115_135528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.8843 7.45075C27.0072 16.1643 8.86117 16.422 0.547238 16.065C23.1752 17.6245 32.2311 11.5548 36.652 8.31787C36.9411 8.10621 36.9746 7.69613 36.7156 7.44858C36.4854 7.22857 36.1115 7.2277 35.8843 7.45075Z",
    fill: "url(#paint1_linear_46115_135528)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2002 12L40.7404 13.4598L42.2002 14L40.7404 14.5402L40.2002 16L39.66 14.5402L38.2002 14L39.66 13.4598L40.2002 12Z",
    fill: "url(#paint2_linear_46115_135528)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46115_135528",
    x1: 35.2661,
    y1: 8.9336,
    x2: 43.0001,
    y2: 8.9336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D982D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46115_135528",
    x1: 0.579514,
    y1: 16.7449,
    x2: 37.5379,
    y2: 14.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D982D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_46115_135528",
    x1: 38.2002,
    y1: 16,
    x2: 42.2002,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D982D9"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRocket);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rocket.ae93990d0e9bd4e6692d0eb350b863e5.svg";